"use client";

import { Alert, AlertDescription } from "@watt/ui/components/ui/alert";
import { useSearchParams } from "next/navigation";

const errorMessages: Record<string, string> = {
  unauthorized_access: "You do not have permission to access this application."
};

export function LoginErrorAlert() {
  const searchParams = useSearchParams();
  const error = searchParams.get("error");

  if (!error || !errorMessages[error]) {
    return null;
  }

  return (
    <Alert className="mb-4" variant="destructive">
      <AlertDescription>{errorMessages[error]}</AlertDescription>
    </Alert>
  );
}
